import { TabInterface } from "components/layout/interfaces";
import Tabs from "components/layout/tabs";
import View from "components/layout/view";
import Title from "components/title";
import { useLocale } from "stores/hooks/locale";
import { parse } from "lib/locale";
import BaseTab from "./base/base-tab";
import EntitiesTab from "./entities/entities-tab";
import { useListTemplate } from "stores/hooks/list-template";

const AdminListTemplateView = () => {
  const listTemplate = useListTemplate();
  const locale = useLocale();

  if (!listTemplate) {
    return null;
  }

  const tabs: TabInterface[] = [
    {
      key: "base",
      label: "Asetukset",
      render: () => <BaseTab />,
    },
    {
      key: "entities",
      label: "Luottelon rakenne",
      render: () => <EntitiesTab listTemplate={listTemplate} />,
    },
  ];

  const title = ["Luettelomalli", parse(listTemplate.name, locale)].join(": ");
  return (
    <View title={title} description="">
      <Title>{title}</Title>
      <Tabs name={`list-template-${listTemplate.uuid}`} tabs={tabs} />
    </View>
  );
};

export default AdminListTemplateView;
